var _a;
import { system } from '@config/system';
import { isEnvironment } from '@config/types';
import { getScriptAttributes } from '@config/helpers';
// Attributes from the current script tag
// All attributes are converted to camelCase format
const scriptAttributes = getScriptAttributes();
const getAppEnv = () => {
    var _a;
    const env = (_a = scriptAttributes['environment']) !== null && _a !== void 0 ? _a : scriptAttributes['env'];
    return isEnvironment(env) ? env : 'prod';
};
const scriptIsland = scriptAttributes['island'];
// Optional override for the chunk/asset host (controls __webpack_public_path__
// via getAssetPath), e.g. to point chunks at a local dev server with env=prod.
const scriptStaticFiles = (_a = scriptAttributes['staticFiles']) !== null && _a !== void 0 ? _a : scriptAttributes['staticFilesUrl'];
system.load(Object.assign(Object.assign(Object.assign({ environment: getAppEnv(), experience: 'immersive' }, (scriptIsland && { island: scriptIsland })), { nodeEnv: 'production', propertyCode: scriptAttributes['propertyCode'], scriptAttributes }), (scriptStaticFiles && { staticFiles: scriptStaticFiles })));
